import { FLIGHT_ITINERARY_TYPE_MICRO } from '@app/enums';
import { FlightSummary } from '../flight-summary.model';
import { Reservation } from '../reservation.model';
import { IROPS_STATUS, IROPS_FLIGHT_EXCHANGE_TYPE } from '@app/enums/irops.enum';
import { CabinInfo } from '@app/interfaces/micro/cabin.interface';

export class RequestSearchFlightIrops {
  fareFamily: string;
  exchangeType: string;
  legRegion: string;
  currency = 'MXN';
  pointOfSale = 'MX';
  flightsInfo: FlightsInfo[];
  cabins = null;
  constructor(reservation: Reservation, departureDate: string, cabin?: CabinInfo[]) {
    const { isNewBF } = reservation;
    this.fareFamily = reservation.flightSummary.fareFamily;
    this.exchangeType = this.getExchangeType(reservation);
    this.legRegion = reservation.flightSummary.legRegion;
    this.flightsInfo = [new FlightsInfo(reservation.flightSummary, departureDate)];
    this.cabins = isNewBF ? cabin : null;
  }

  getExchangeType(reservation: Reservation) {
    //RT--si cambian ambos legs es both ????
    // console.log('[itineraryPartType]', reservation.flightSummary.itineraryPartType);
    let exchangeType = '';
    const hasSegmentUsed = reservation.passengers.some((p) =>
      p.ticketInfo?.coupons?.some((co) => co.couponStatus == IROPS_STATUS.USED)
    );
    if (reservation.tripType == FLIGHT_ITINERARY_TYPE_MICRO.ONEWAY) {
      //si un cupon viene en used aplica el itinerary (tomarlo del primer pasajero)
      //si no esta usado un cupon aplica outbound (tomarlo del primer pasajero)
      exchangeType = hasSegmentUsed
        ? IROPS_FLIGHT_EXCHANGE_TYPE.ITINERARY
        : IROPS_FLIGHT_EXCHANGE_TYPE.OUTBOUND;
    } else if (reservation.tripType == FLIGHT_ITINERARY_TYPE_MICRO.ROUNDTRIP) {
      if (reservation.flightSummary.itineraryPartType == 'outbound') {
        // primer leg (ida)
        //RT--mi primer leg esta usado  aplica el itinerary (tomarlo del primer pasajero)
        //RT--si el leg de ida esta afectado es outbound
        exchangeType = hasSegmentUsed
          ? IROPS_FLIGHT_EXCHANGE_TYPE.ITINERARY
          : IROPS_FLIGHT_EXCHANGE_TYPE.OUTBOUND;
      } else {
        // RT leg inbound: si hay cupón USED en el itinerario (p. ej. ida volada, regreso vivo), backend espera itinerary.
        exchangeType = hasSegmentUsed
          ? IROPS_FLIGHT_EXCHANGE_TYPE.ITINERARY
          : IROPS_FLIGHT_EXCHANGE_TYPE.INBOUND;
      }
    }
    console.log('exchangeType', exchangeType);
    return exchangeType;
  }
}

export class FlightsInfo {
  departure: string;
  arrival: string;
  departureDate: string;
  originalDepartureDateTime: string;
  flightStatusSegment?: string;

  constructor(flightSummary: FlightSummary, departureDate: string) {
    const { currentSegment } = flightSummary;
    const validAfect =
      currentSegment.flightsNewInfo?.status == IROPS_STATUS.DELAYED ||
      currentSegment.flightsNewInfo?.status == IROPS_STATUS.EARLY;

    this.departure = currentSegment.departureAirport;
    this.arrival = currentSegment.arrivalAirport;
    this.departureDate = departureDate
      ? departureDate
      : currentSegment.departureDateTime.split('T')[0];
    this.originalDepartureDateTime = validAfect
      ? currentSegment.flightsNewInfo?.originalDepartureTime ||
        currentSegment.flightsNewInfo?.departureDateTime
      : currentSegment.departureDateTime;
    this.flightStatusSegment = currentSegment.flightStatus === IROPS_STATUS.CANCELLED
      ? currentSegment.flightStatus
      : undefined;
  }
}
